const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    marginTop: '24px',
  },
  headerText: {
    fontSize: '24px',
    fontWeight: 600,
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  sortSelect: {
    minWidth: '200px',
    height: '36px',
    '& .MuiOutlinedInput-root': {
      height: '36px',
    },
  },
  select: {
    '& .MuiSelect-select:focus': {
      backgroundColor: 'transparent',
    },
  },
  searchContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px',
  },
  searchField: {
    minWidth: '200px',
    height: '36px',
    '& .MuiOutlinedInput-root': {
      height: '36px',
      borderRadius: '8px',
      '&:hover fieldset': {
        borderColor: '#015FFB',
      },
    },
  },
  sortField: {
    minWidth: '200px',
    height: '36px',
    '& .MuiOutlinedInput-root': {
      height: '36px',
      borderRadius: '8px',
      '&:hover fieldset': {
        borderColor: '#015FFB',
      },
    },
    '& .MuiInputAdornment-root': {
      marginRight: 0,
    },
  },
  menuItem: {
    '&:hover': {
      backgroundColor: '#015FFB',
      color: '#FFFFFF',
    },
    '&.Mui-selected': {
      backgroundColor: '#015FFB',
      color: '#FFFFFF',
      '&:hover': {
        backgroundColor: '#015FFB',
        color: '#FFFFFF',
      },
    },
  },
})

export default styles
